import { useAchievementInfo, useAppContext } from '@frx/frx-react-context';
import { Clock, Heart, PartyHorn, PeopleGroupOutline } from '../assets';
import { useEventId } from './use-eventId';

export const useShareMessage = () => {
  const {
    data: {
      authData: { user },
      eventData: { eventInfo },
    },
  } = useAppContext();
  const eventId = useEventId();
  // TODO: Currently it is using the achievements hook for fetching the info, update it to it's own hook
  const { data: participantInfo }: any = useAchievementInfo({
    teamName: `[[S48:${eventId}:team-name]]`,
    amountRaised: `[[S48:${eventId}:dollars]]`,
    goal: `[[S48:${eventId}:goal]]`,
  });

  const sanitizeHTML = (template = '') => {
    const args = {
      amountRaised: participantInfo?.amountRaised || 0,
      eventName: eventInfo?.name || '',
      fundraisingGoal: participantInfo?.goal || 0,
      participantName: `${user?.name?.first} ${user?.name?.last}`,
      personalPage: user?.customPersonalPageUrl || user?.personalPageUrl || '',
      teamName: participantInfo?.teamName || '',
      teamPage: user?.teamPageUrl || '',
    };

    return Object.entries(args)
      .reduce(
        (result, [arg, val]) => result?.split(`{${arg}}`).join(`${val}`),
        template
      )
      .replace(/<[^>]+>/g, '');
  };

  const getShareMessageIcon = (key = '') => {
    if (key?.includes('Reminder')) return Clock;
    if (key?.includes('Recruit')) return PeopleGroupOutline;
    if (key?.includes('Gratitude')) return Heart;
    if (key?.includes('Celebrate')) return PartyHorn;
    return undefined;
  };

  return { getShareMessageIcon, sanitizeHTML };
};
